/** Per-browser dismiss list for class announcements (teacher posts stay in DB). */

const STORAGE_KEY = "acuity:student:dismissed-announcements:v1";

/** Parents dismiss on their own list, so a shared browser does not hide the student's copy. */
export const PARENT_ANNOUNCEMENT_DISMISS_KEY = "acuity:parent:dismissed-announcements:v1";

export function announcementKey(a: { id: string }) {
  return a.id;
}

export function loadDismissedAnnouncementKeys(storageKey = STORAGE_KEY): Set<string> {
  try {
    const raw = localStorage.getItem(storageKey);
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
  } catch {
    return new Set();
  }
}

function save(keys: Set<string>, storageKey: string) {
  try {
    localStorage.setItem(storageKey, JSON.stringify([...keys]));
  } catch {
    /* quota / private mode — dismiss is best-effort */
  }
}

export function dismissAnnouncementKey(key: string, storageKey = STORAGE_KEY): Set<string> {
  const next = loadDismissedAnnouncementKeys(storageKey);
  next.add(key);
  save(next, storageKey);
  return next;
}

export function dismissAnnouncementKeys(keys: string[], storageKey = STORAGE_KEY): Set<string> {
  const next = loadDismissedAnnouncementKeys(storageKey);
  for (const key of keys) next.add(key);
  save(next, storageKey);
  return next;
}
